import { CompanyTypeEnum, DisplayNameEnum, UnitTypeEnum } from "@gtpl/shared-models/masters";
import { Column, Entity, Index, PrimaryGeneratedColumn, VersionColumn, UpdateDateColumn, CreateDateColumn, OneToMany } from "typeorm";
import { PalletCapacity } from "../pallet-capacity/pallet-capacity.entity";

@Entity('unitcodes')
export class UnitCodes {

  @PrimaryGeneratedColumn("increment", { name: 'unit_code_id' })
  unitcodeId: number;

  @Column("varchar", {
    nullable: false,
    length: 50,
    name: "unit_name"
  })
  @Index({ unique: false })
  unitcodeName: string;

  @Column({
    type: 'enum',
    enum: UnitTypeEnum,
    nullable: false,
    name: 'plant_type',
    default: UnitTypeEnum.PLANT
  })
  plantType: UnitTypeEnum;

  
  @Column("varchar", {
    nullable: true,
    length: 50,
    name: "village_name"
  })
  // @Index({ unique: false })
  villageName: string;

  @Column("varchar", {
    nullable: true,
    length: 50,
    name: "mandal_name"
  })
  // @Index({ unique: false })
  mandalName: string;

  @Column("varchar", {
    nullable: true,
    length: 50,
    name: "distirct_name"
  })
  // @Index({ unique: false })
  distirctName: string;

  @Column("varchar", {
    nullable: true,
    length: 50,
    name: "state_name"
  })
  // @Index({ unique: false })
  stateName: string;

  @Column("varchar", {
    nullable: true,
    length: 50,
    name: "county_name"
  })
  // @Index({ unique: false })
  countryName: string;

  @Column("varchar", {
    nullable: true,
    length: 50,
    name: "fda_reg_number"
  })
  // @Index({ unique: false })
  fdaRegNumber: string;

  @Column("varchar", {
    nullable: true,
    length: 50,
    name: "fei_number"
  })
  // @Index({ unique: false })
  feiNumber: string;

  @Column("varchar", {
    nullable: true,
    length: 50,
    name: "short_key"
  })
  // @Index({ unique: false })
  shortKey: string;

  @Column("varchar", {
    nullable: true,
    length: 50,
    name: "bap_no"
  })
  // @Index({ unique: false })
  bapNo: string;

  @Column("varchar", {
    nullable: true,
    length: 50,
    name: "approval_no"
  })
  // @Index({ unique: false })
  approvalNo: string;

  @Column("varchar", {
    nullable: true,
    length: 50,
    name: "asc_no"
  })
  // @Index({ unique: false })
  ascNo: string;

  @Column("varchar", {
    nullable: true,
    length: 50,
    name: "walmart_id"
  })
  // @Index({ unique: false })
  walmartId: string;

  @Column("varchar", {
    nullable: true,
    length: 50,
    name: "fishin_approval_no"
  })
  // @Index({ unique: false })
  fishInapprovalNo: string;

  @Column("varchar", {
    nullable: true,
    length: 50,
    name: "kroger_no"
  })
  // @Index({ unique: false })
  krogerNo: string;

  @Column("varchar", {
    nullable: true,
    length: 50,
    name: "postal_code"
  })
  // @Index({ unique: false })
  postalCode: string;

  @Column("varchar", {
    nullable: true,
    length: 50,
    name: "plant_code"
  })
  // @Index({ unique: false })
  plantCode: string;

  @Column("boolean", {
    nullable: false,
    default: true,
    name: "is_active"
  })
  isActive: boolean;

  @CreateDateColumn({
    name: "created_at",
    type: "datetime"
  })
  createdAt: Date;

  @Column("varchar", {
    nullable: false,
    name: "created_user",
    length: 50
  })
  createdUser: string | null;


  @UpdateDateColumn({
    name: "updated_at",
    type: 'datetime'
  })
  updatedAt: Date;

  @Column("varchar", {
    nullable: true,
    name: "updated_user",
    length: 50
  })
  updatedUser: string | null;

  @VersionColumn({
    default: 1,
    name: "version_flag"
  })
  versionFlag: number;

  @Column("varchar",{
    nullable:false,
    name:"company",
    // enum: CompanyTypeEnum,
})
company:String;

@Column({
  type: 'enum',
  nullable:true,
  name:"display_name",
  enum: DisplayNameEnum,
})
displayName:String;

@Column("int",{
  nullable:false,
  name:"company_id",
  // enum: CompanyTypeEnum,
})
companyId:number;

  @OneToMany(type => PalletCapacity , palletCapacity => palletCapacity.unitCodeInfo)
  palletCapacity:PalletCapacity
}
